import styled from "styled-components";
import { Colors } from "../../config/Constants";
import { InputFieldWrapper, Label } from "../Events/Datefield";

interface Props {
  label?: string;
  subLabel?: string;
  maxImages: number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemove: (e: any) => void;
  name: string;
  uploadedImage: any;
  required: boolean;
  helperText: string;
  urls: any;
  acceptFormats: string;
}

interface StyledInputProps {
  helperText: string;
  disabled?: boolean;
}

const UploadAccountImages = ({
  onChange,
  onRemove,
  label,
  name,
  required,
  helperText,
  subLabel,
  maxImages,
  urls,
  acceptFormats,
}: Props) => {
  return (
    <>
      <InputFieldWrapper>
        <UploadWrapper helperText={helperText}>
          <div>
            <div>
              {label && (
                <Label>
                  {label}
                  {required && <span>*</span>}
                </Label>
              )}
              {maxImages > 1 && (
                <MaxStatement> (Maximum {maxImages} images)</MaxStatement>
              )}
            </div>
            <SubLabel>{subLabel}</SubLabel>
          </div>
          <InputField
            onChange={onChange}
            name={name}
            autoComplete="off"
            type="file"
            accept={acceptFormats}
            id={name}
            hidden
          />
          <UploadButton
            htmlFor={name}
            disabled={urls.length === maxImages}
            helperText={helperText}
          >
            Select File
          </UploadButton>
        </UploadWrapper>
        {helperText && <Error>{helperText}</Error>}
        <AllUploadWrapper>
          {urls.length > 0 &&
            urls.map((eachUrl: any, i: number) => {
              return (
                <PreviewWrapper key={i}>
                  <PreviewImage
                    src={eachUrl.viewUrl}
                    width="38px"
                    height="38px"
                  />
                  <PreviewName>
                    {eachUrl.originalname} <br />
                  </PreviewName>
                  <PreviewDelete onClick={() => onRemove(eachUrl.viewUrl)}>
                    <img
                      src={require("../../assets/images/close_img_up.png")}
                      alt="delete"
                      width="24px"
                      height="24px"
                    />
                  </PreviewDelete>
                </PreviewWrapper>
              );
            })}
        </AllUploadWrapper>
      </InputFieldWrapper>
    </>
  );
};

const UploadWrapper = styled.div<StyledInputProps>`
  padding: 0.5rem;
  border-radius: 0.25rem;
  display: flex;
  justify-content: space-between;
  border: 1px solid ${(props) => (props.helperText ? "red" : "transparent")};
`;

const InputField = styled.input`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8125rem;
  line-height: 0.75rem;
  ::placeholder {
    color: ${Colors.autumnFog};
  }
  :focus {
    outline: none;
  }
  :disabled {
    background: ${Colors.white};
    color: ${Colors.cloudyGrey};
    cursor: no-drop;
  }
`;

const UploadButton = styled.label<StyledInputProps>`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8125rem;
  width: 6.25rem;
  height: 2rem;
  background: ${Colors.red};
  border-radius: 0.5rem;
  border: none;
  cursor: ${(props) => (props.disabled ? "" : "pointer")};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.white};
  pointer-events: ${(props) => (props.disabled ? "none" : "")};
  opacity: ${(props) => (props.disabled ? "0.5" : "")};
`;

const AllUploadWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const PreviewWrapper = styled.div`
  display: flex;
  margin: 0.5rem 0;
  position: relative;
  border: 1px solid ${Colors.dustyGray};
  border-radius: 0.25rem;
  background: ${Colors.whiteSmoke};
  width: 100%;
  flex: 1 1 15rem;
`;

const PreviewImage = styled.img`
  padding: 0.5rem;
`;

const PreviewName = styled.div`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 0.75rem;
  color: ${Colors.comet};
  margin-top: 1.25rem;
  margin-left: 0.5rem;
`;

const PreviewDelete = styled.div`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 0.75rem;
  color: ${Colors.appleRed};
  position: absolute;
  right: 2%;
  margin-top: 1rem;
  cursor: pointer;
   > img{
    width:1rem;
    height:1rem;
   }
`;

const MaxStatement = styled.span`
  font-family: "Poppins-Book";
  font-style: normal;
  font-size: 0.625rem;
  color: ${Colors.cloudyGrey};
`;
const SubLabel = styled.div`
  font-family: "Poppins-Book";
  font-style: normal;
  font-size: 0.5rem;
  color: ${Colors.cloudyGrey};
  margin-top: 0.5rem;
`;

const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export default UploadAccountImages;
